/**
 * Handle lazy-loading the dependencies of the lightbox if
 * one or more is encountered on page
 * 
 * @param {string} selector 
 */

const Lightbox = (selector = '[data-lightbox]') => {
    if (document.querySelectorAll(selector)) {
        import(
            /* webpackChunkName: 'lightbox' */
            './lightbox'
        ).then(({ default: LightboxInstance }) => {
            LightboxInstance(selector);
        });
    }
};

export default Lightbox;